import type { ZeytalCLIPureConfig } from "@zeytal/kit";
import type { FigmaRestApi } from "@zeytal/types";

import {
  calculateGradientColorStops,
  calculateRadialGradientPosition,
} from "../../../utils/colors.ts";

export function createRadialGradient(
  stylesFormatsConfig: ZeytalCLIPureConfig["styles"]["formats"],
  paint: FigmaRestApi.GradientPaint,
): string {
  const { gradientHandlePositions, gradientStops } = paint;
  let value = "radial-gradient(";

  value += calculateRadialGradientPosition(gradientHandlePositions);

  value += calculateGradientColorStops(stylesFormatsConfig, gradientStops);

  value += ")";

  return value;
}
